import React, { useEffect } from 'react';
import { Paper, Box, Tab, Tabs } from '@material-ui/core';
import DataTableNativeML from '@/components/DataTableNativeML';
import { fmtThousand } from '@/utils/comUtil';
import { useIntl } from 'umi';
import request from '@/utils/request';
import DetailTableStyled from './detaulTableStyles';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
export default ({ orderData, devicesMinWidth }) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const [tabValue, setTabValue] = React.useState(0);
  const [orderPayment, setOrderPayment] = React.useState([]);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const columnsOne = [
    {
      title: formatMessage({ id: 'order.order.detail.c01.lbl02' }),
      align: 'center',
      id: 'skuId',
      // key: 'comment',
      // width: 120,
    },
    {
      align: 'center',
      title: formatMessage({ id: 'order.order.detail.c01.lbl03' }),
      id: 'skuName',
      width: '200',
    },
    {
      title: formatMessage({ id: 'order.order.detail.c01.lbl04' }),
      align: 'right',
      id: 'quantity',
      width: '90',
    },
    {
      title: formatMessage({ id: 'order.order.detail.c01.lbl05' }),
      id: 'unitPrice',
      // key: 'usedTypeName',
      // width: 120,
      align: 'right',
      render: (item) => {
        return fmtThousand(item.unitPrice);
      },
    },
    {
      title: formatMessage({ id: 'order.order.detail.c01.lbl06' }),
      align: 'right',
      id: 'subtotal',
      // width: 220,
      render: (item) => {
        return fmtThousand(item.subtotal);
      },
    },
    {
      title: formatMessage({ id: 'order.order.detail.c01.lbl16' }),
      align: 'right',
      id: 'subpayment',
      render: (item) => {
        return fmtThousand(item.subpayment);
      },
    },
    {
      title: formatMessage({ id: 'order.order.detail.c01.lbl07' }),
      align: 'right',
      id: 'subpaid',
      render: (item) => {
        return fmtThousand(item.subpaid);
      },
    },
    {
      title: formatMessage({ id: 'order.order.detail.c01.lbl08' }),
      align: 'right',
      id: 'discountPrice',
      render: (item) => {
        return fmtThousand(item.discountPrice);
      },
    },
  ];
  const columnsTwo = [
    {
      align: 'center',
      title: formatMessage({ id: 'order.order.detail.c01.lbl10' }),
      id: 'code',
      width: '200',
    },
    {
      title: formatMessage({ id: 'order.order.detail.c01.lbl11' }),
      align: 'center',
      id: 'type',
      // key: 'comment',
      // width: 120,
    },
    {
      title:
        formatMessage({ id: 'order.order.detail.c01.lbl12' }) +
        '/' +
        formatMessage({ id: 'report.retail.detail.c01.lbl18' }),
      align: 'center',
      id: 'amount',
      render: (item) => {
        return fmtThousand(item.amount);
      },
    },
  ];
  const columnsThree = [
    {
      align: 'center',
      title: formatMessage({ id: 'order.order.detail.c01.lbl14' }),
      id: 'point',
      width: '200',
    },
    {
      title: formatMessage({ id: 'order.order.detail.c01.lbl15' }),
      align: 'center',
      id: 'remark',
      // key: 'comment',
      // width: 120,
    },
  ];
  const columnsFour = [
    {
      align: 'center',
      title: '支付方式',
      id: 'payWay',
      width: '200',
    },
    {
      title: '支付金额',
      align: 'center',
      id: 'payPrice',
      // key: 'comment',
      // width: 120,
    },
    {
      title: '备注',
      align: 'center',
      id: 'description',
      // key: 'comment',
      // width: 120,
    },
  ];

  useEffect(() => {
    if (!orderData.id) {
      return false;
    }
    request('/order/queryOrderDetail', {
      method: 'POST',
      data: { id: orderData.id },
    }).then((res) => {
      const orderPayments = res.data.orderPayments;
      setOrderPayment(orderPayments);
    }).catch(()=>{});
  }, [orderData.id]);
  return (
    <DetailTableStyled>
      <Paper sx={{ padding: '16px 24px 31px', borderRadius: '4px' }}>
        <Box>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="basic tabs"
          >
            <Tab
              label={formatMessage({ id: 'order.order.detail.c01.lbl01' })}
              sx={{ fontSize: '16px' }}
              {...a11yProps(0)}
            />
            <Tab
              label={formatMessage({ id: 'order.order.detail.c01.lbl09' })}
              sx={{ fontSize: '16px' }}
              {...a11yProps(1)}
            />
            <Tab
              label={formatMessage({ id: 'order.order.detail.c01.lbl13' })}
              sx={{ fontSize: '16px' }}
              {...a11yProps(2)}
            />
            <Tab
              label="支付方式"
              sx={{ fontSize: '16px' }}
              {...a11yProps(3)}
            />
          </Tabs>
        </Box>
        <Box mt={2.125} overflow="auto">
          <TabPanel className="tab-panel" value={tabValue} index={0}>
            <DataTableNativeML
              columns={columnsOne}
              data={orderData?.orderItems || []}
              columnKey="id"
              // devicesMinWidth='100'
              np={true}
              pageButton={false}
            ></DataTableNativeML>
          </TabPanel>
          <TabPanel className="tab-panel" value={tabValue} index={1}>
            <DataTableNativeML
              columns={columnsTwo}
              data={orderData?.orderCoupons || []}
              columnKey="id"
              devicesMinWidth={devicesMinWidth}
              np={true}
              pageButton={false}
            ></DataTableNativeML>
          </TabPanel>
          <TabPanel className="tab-panel" value={tabValue} index={2}>
            <DataTableNativeML
              columns={columnsThree}
              data={orderData?.orderPoints || []}
              columnKey="id"
              // devicesMinWidth='100'
              devicesMinWidth={devicesMinWidth}
              np={true}
              pageButton={false}
            ></DataTableNativeML>
          </TabPanel>
          <TabPanel className="tab-panel" value={tabValue} index={3}>
            <DataTableNativeML
              columns={columnsFour}
              data={orderPayment}
              columnKey="id"
              // devicesMinWidth='100'
              devicesMinWidth={devicesMinWidth}
              np={true}
              pageButton={false}
            ></DataTableNativeML>
          </TabPanel>
        </Box>
      </Paper>
    </DetailTableStyled>
  );
};
